import { Component, OnInit, Renderer, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { T2ThemeService} from '../../t2-theme.service';
import { Router, NavigationEnd } from '@angular/router';
import { T2LoadingService } from '../t2-loading/t2-loading.service';
import { Subscription } from 'rxjs/Subscription';
import { UsersService } from '../../../pages/users/users.service';
declare var $: any;

@Component({
  selector: 'app-t2-menu',
  templateUrl: './t2-menu.component.html',
  styleUrls: ['./t2-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class T2MenuComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  private menuSideBarBtn: any;
  private isSubmenu= true;
  private parentPath= '/pages';
  private pathMainMenu = '';
  private isDashboardItem = false;
  private token: any;
  private isNormalRoute = false;
  private isHrefRoute= false;
  private hrefValue: any;
  private hostname: string;
  menu = [];
  nameSearch = '';

  constructor(
    private _menuService: T2ThemeService,
    private renderer: Renderer,
    private router: Router,
    private t2LoadingService: T2LoadingService,
    private userService: UsersService
  ) {
    const user = JSON.parse(localStorage.getItem('currentUser'));
    const host = window.location.hostname;
    this.hostname = (host.split('.', 1))[0];
    this.token = user ? user.token : '';

    router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // this.closeLevel1();
        }
      });
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.userService.currentUserInformation$
        .subscribe({
          next: (currentUserData) => {
            if (currentUserData) {
              this.loadSideBar(currentUserData);
            }
          }
        })
    );
  }

  closeLevel1 () {
    $('.layout-main-menu').removeClass('active');
    $('app-t2-sidebar').removeClass('active');
    $(`.layout-main-menu [data-level="1"]`)
      .each(function (index, element) {
        $(element).removeClass('active');
      });
  }

  openChildrens (event, level) {
    const item = $(event.target).closest('li');
    if (item.hasClass('active')) {
      if (level === 1) {
        $(event.target).closest('app-t2-sidebar').removeClass('active');
        $(event.target).closest('.layout-main-menu').removeClass('active');
      }
      item.removeClass('active');
      return false;
    }
    if (level === 1) {
      $(event.target).closest('app-t2-sidebar').addClass('active');
      $(event.target).closest('.layout-main-menu').addClass('active');
    }

    $(`.layout-main-menu [data-level="${level}"]`)
      .each(function (index, element) {
        $(element).removeClass('active');
      });
    item.addClass('active');
  }

  ngAfterViewInit () {
    const self = this;
    $('body')
      .on('click', '.close-main-menu', () => {
        this.closeMenus();
      });
  }

  closeMenus() {
    $('.layout-main-menu').removeClass('active');
    $('app-t2-sidebar').removeClass('active');
    this.closeLevel1();
  }

  /**
   * @Description:
   * @param data
   */
  loadSideBar(data) {
    const me = this;
    this._menuService.getMenuByRoleId(data.roleid).subscribe(
      res => {
        this.menu = res;
      }
    );
  }
  getLink(data) {
    this.t2LoadingService.show();
    this._menuService.getTokenSetVersion().subscribe(
      res => {
        this.t2LoadingService.hiden()
        const url = `http://${this.hostname}v.trip2.com/#/login/${res}/pages&${data}`;
        window.location.href = url;
      }, err => this.t2LoadingService.hiden()
    );
  }

  onSearchMenu() {
    this.menuFilter(this.nameSearch);
  }

  menuFilter(text) {
    let list = $('li li')
      .hide()
      .filter(function () {
        let item = $(this).text();
        let padrao = new RegExp(text, 'i');
        return padrao.test(item);
      }).closest('li li').show().addClass('active');
    if (!list.length || !this.nameSearch) $('li li').show().removeClass('active');
  }

  onClear() {
    if (this.nameSearch) $('li li').show().removeClass('active'); this.nameSearch = '';
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-menu/t2-menu.component.ts